'use strict';

(function (angular, window) {

    angular
        .module('jwsdw.basket')
        .constant('BASKET_ID', window.jwsdwSettings.basket.id)
        .constant('LIST_PRICE_BOOK', window.jwsdwSettings.listPriceBook)
        .constant('SALE_PRICE_BOOK', window.jwsdwSettings.salePriceBook)
        .constant('IMAGE_BASE_URL', window.jwsdwSettings.productGetImageBaseUrl)
        .constant('SETTINGS', window.jwsdwSettings);
}(angular, window));